import classnames from "classnames";
import _ from "lodash";
import React, { useContext, useEffect, useState } from "react";
import { FaBars, FaDesktop, FaMobile, FaUserCircle } from "react-icons/fa";
import { RiPushpin2Fill, RiPushpinLine } from "react-icons/ri";
import { VscSignOut } from "react-icons/vsc";
import { NavLink, useLocation, useNavigate } from "react-router-dom";
import Sidebar from "react-sidebar";
import {
  Button, Col, Dropdown, DropdownItem, DropdownMenu, DropdownToggle,
  Nav, NavItem, NavLink as ReactStrapNavLink, Row
} from "reactstrap";
import Logo from "../assets/images/logoSmall.png";
import { constants, helpers, sidebarLinks, UserContext } from "../utils";

const LinkItem = (link, index, sidebarOpen, pathname, closeSideBar) => {
  let active = pathname === link.url;
  if (link.url) {
    return (
      <NavItem
        key={`${sidebarOpen ? "open" : "closed"}Link${index}`}
        title={link.title}
        className="fullWidthLinkItem"
        onClick={() => (sidebarOpen ? closeSideBar(!sidebarOpen) : null)}
      >
        <ReactStrapNavLink
          tag={NavLink}
          to={link.url}
          active={active}
          className="p-0"
        >
          <Row className="mx-0 my-1 p-0 align-items-center justify-content-center menuButtonColor">
            <Col xs={sidebarOpen ? "3" : "12"} className="p-0 m-0">
              {link.icon}
            </Col>
            {sidebarOpen && (
              <Col xs={9} className={`${active ? "active" : ""} ps-1 text-nowrap menuButtonColor`}>
                {link.title}
              </Col>
            )}
          </Row>
        </ReactStrapNavLink>
      </NavItem>
    );
  }
};

function DropdownLinkItem({item, index, sidebarOpen, pathname, closeSideBar}) {
  const [openDDL, setOpenDDL] = useState(false);
  let navigate = useNavigate();

  function openLink(url) {
    setOpenDDL(false);
    if (sidebarOpen) {
      closeSideBar(!sidebarOpen);
    }
    navigate(url);
    // window.open(url, "_blank", "noreferrer");
  }

  if (!item || !item.dropdownMenu || item.dropdownMenu.length === 0) {
    console.warn("No dropdown items for this parent item - correct configuration", item);
    return <div />;
  }
  return (
    <Dropdown
      nav
      toggle={() => setOpenDDL(!openDDL)}
      title={item.title}
      className="fullWidthLinkItem dropdownList"
      isOpen={openDDL}
      inNavbar={true}
    >
      <DropdownToggle
        // caret={sidebarOpen ? true : false}
        caret={false}
        nav
      >
        <Row className="mx-0 my-1 p-0 align-items-center justify-content-center menuButtonColor">
          <Col xs={sidebarOpen ? "3" : "12"} className="p-0 m-0">
            {item.icon}
          </Col>
          {sidebarOpen && (
            <Col xs="9" className="ps-1 text-nowrap menuButtonColor">
              {item.title}
            </Col>
          )}
        </Row>
      </DropdownToggle>
      <DropdownMenu direction={sidebarOpen ? "down" : "right"} className="ms-2">
        {_.map(item.dropdownMenu, (link, index) => {
          return (
            <DropdownItem
              href={link.url}
              key={index}
              onClick={() => openLink(link.url)}
              children={link.title}
            />            
          );
        })}
      </DropdownMenu>
    </Dropdown>
  );
}

// Switching between the desktop and the mobile UIs is for staff only: customers are always on the
// desktop, and an account with no roles has nothing to open in any UI (the server 403s it everywhere).
function canUserSwitchUI(user) {
  return !!user && !user.isAnyCustomerTypeRole && !helpers.hasNoRoles(user);
}

export default function SidebarMenu() {
  const userCtx = useContext(UserContext);
  const navigate = useNavigate();
  const [currentUser, setCurrentUser] = useState(userCtx?.currentUser ? userCtx.currentUser : null);
  const [links, setLinks] = useState([]);
  const [sidebarOpen, setSidebarOpen] = useState(true);
  const [canSwitchUI, setCanSwitchUI] = useState(canUserSwitchUI(currentUser));
  // No Profile link for an account with no roles: the profile screen's calls 403 for it.
  const showProfile = !helpers.hasNoRoles(currentUser);
  let location = useLocation();

  useEffect(() => {
    setCurrentUser(userCtx?.currentUser ? userCtx.currentUser : null);
    if (
      (userCtx.currentUser && _.includes(window.location.pathname, "mobile")) ||
      (userCtx.currentUser && !userCtx.pinnedState)
    ) {
      setSidebarOpen(false);
    } else if (userCtx.currentUser) {
      setSidebarOpen(true);
    }
    setLinks(sidebarLinks.resolveLinks(userCtx?.onMobile, userCtx?.currentUser?.menus));
    setCanSwitchUI(canUserSwitchUI(userCtx?.currentUser));
  }, [userCtx]);

  function toggleSidebar(openOrClose, specialParam = false) {
    if (userCtx.pinnedState && specialParam === false) return;
    setSidebarOpen(openOrClose);
  }

  const menuStyling = classnames(
    {
      stickyLeftMenuOpen: sidebarOpen,
      stickyLeftMenuCollapsed: !sidebarOpen,
    },
    "stickyLeftMenu p-0 m-0 py-2 width40px"
  );

  const menuStylingDeskTop = classnames(
    {
      stickyLeftMenuOpen: sidebarOpen,
      stickyLeftMenuCollapsed: !sidebarOpen,
    },
    "stickyLeftMenu p-0 m-0 py-2"
  );

  let mobileMenu = (
    <div className={`${menuStyling}`}>
      <div className="topLeftMenuSection">
        <Row
          className="m-0 mb-2 p-0 align-items-center justify-content-center"
          onClick={() => toggleSidebar(!sidebarOpen)}
        >
          <Col className="p-0 m-0">
            <FaBars className="leftMenuButtons align-self-center cursor-pointer" />
          </Col>
        </Row>
        <Nav vertical={"true"}>
          {LinkItem(
            {
              url: constants.ENDPOINTS.mobileHome,
              title: "",
              icon: sidebarLinks.ICONS.homeIcon,
            },
            -1,
            sidebarOpen,
            constants.ENDPOINTS.mobileHome,
            toggleSidebar
          )}

          {links && links.length > 0
            ? _.map(links, (l, index) => {
                if (l.parent) {
                  return <DropdownLinkItemMobile key={index} item={l} />;
                }
                return LinkItem(l, index, sidebarOpen, location?.pathname, toggleSidebar);
              })
            : null}
        </Nav>
      </div>
      <div className="bottomLeftMenuSection ">
        <Nav vertical={"true"}>
          {canSwitchUI && (
            <NavItem
              title="Switch to Desktop"
              onClick={() => {
                userCtx.setOnMobile(false);
                userCtx.setPinned(false, true);
                navigate(constants.ENDPOINTS.home);
                if (sidebarOpen) toggleSidebar(!sidebarOpen);
              }}
            >
              <Row className="m-0 p-0 align-items-center justify-content-center">
                <Col xs={12} className="p-0 m-0 dropbtn">
                  <FaDesktop className="leftMenuButtons align-self-center menuButtonColor" />
                </Col>
              </Row>
            </NavItem>
          )}
          {canSwitchUI && (
            <NavItem
              title="Switch to New Mobile"
              onClick={() => {
                // /m/* is a separate SPA on the same origin — full-page nav,
                // not react-router navigate(). JWT + onMobile persist via
                // shared localStorage; the new app reads them on load.
                window.location.href = constants.ENDPOINTS.newMobileHome;
              }}
            >
              <Row className="m-0 p-0 align-items-center justify-content-center">
                <Col xs={12} className="p-0 m-0 dropbtn">
                  <FaMobile className="leftMenuButtons align-self-center menuButtonColor" />
                </Col>
              </Row>
            </NavItem>
          )}
          {showProfile && (
            <NavItem
              key={`${sidebarOpen ? "open" : "closed"}2LinkProfile`}
              title="Profile"
              className="fullWidthLinkItem"
            >
              <ReactStrapNavLink
                tag={NavLink}
                to={"/profile"}
                className="p-0 menuButtonColor"
                active={location.pathname === "/profile"}
                onClick={sidebarOpen ? () => toggleSidebar(!sidebarOpen) : null}
              >
                <Row className="mx-0 my-1 p-0 align-items-center justify-content-center">
                  <Col xs={12} className="p-0 m-0">
                    <FaUserCircle className="leftMenuButtons align-self-center profileButton" />
                  </Col>
                </Row>
              </ReactStrapNavLink>
            </NavItem>
          )}
          <NavItem
            key={`${sidebarOpen ? "open" : "closed"}LinkSignOut`}
            title={userCtx.impersonating ? "Stop Impersonating" : "Sign Out"}
            className="fullWidthLinkItem"
          >
            <ReactStrapNavLink
              className="p-0 menuButtonColor"
              onClick={() => userCtx.signOut(null, false)}
            >
              <Row className="mx-0 my-1 p-0 align-items-center justify-content-center menuButtonColor">
                <Col xs={12} className="p-0 m-0">
                  <VscSignOut
                    style={{ paddingLeft: "2rem" }}
                    className="leftMenuButtons align-self-center signOutButton flipHorizontal"
                  />
                </Col>
              </Row>
            </ReactStrapNavLink>
          </NavItem>
        </Nav>
      </div>
    </div>
  );

  const PinSideBar = () => {
    userCtx.setPinned();
  };

  let menu = (
    <div className={`${menuStylingDeskTop} lightGraySidebar`}>
      <div className="topLeftMenuSection">
        <Row
          className="m-0 mb-2 p-0 align-items-center justify-content-center"
          onClick={() => toggleSidebar(!sidebarOpen)}
        >
          <Col xs={sidebarOpen ? "2" : "12"} className="p-0 m-0">
            <FaBars className="leftMenuButtons align-self-center" />
          </Col>
          {sidebarOpen && (
            <Col xs="9" className="text-left">
              <img
                id="LogoSideBar"
                src={Logo}
                alt="logo"
                style={{ maxWidth: "150px" }}
              />
            </Col>
          )}
        </Row>
        <Nav vertical={"true"}>
          {LinkItem(
            {
              url: constants.ENDPOINTS.home,
              title: "Home",
              icon: sidebarLinks.ICONS.homeIcon,
            },
            -1,
            sidebarOpen,
            location?.pathname,
            toggleSidebar
          )}
          {links && links.length > 0
            ? _.map(links, (l, index) => {
                if (l.parent && !l.isClickableParent) {
                  return (
                    <DropdownLinkItem
                      style={{ color: "orange" }}
                      item={l}
                      index={index}
                      key={index}
                      sidebarOpen={sidebarOpen}
                      closeSideBar={toggleSidebar}
                    />
                  );
                }
                return LinkItem(l, index, sidebarOpen, location?.pathname, toggleSidebar);
              })
            : null}
        </Nav>
      </div>

      <div className="bottomLeftMenuSection ">
        <Nav vertical={"true"}>
          <NavItem
            key={`${sidebarOpen ? "open" : "closed"}1LinkProfile`}
            title="Pin On/Off"
            className="fullWidthLinkItem"
          >
            <Row
              className="m-0 p-0 align-items-center justify-content-center"
              style={{ cursor: "pointer" }}
              onClick={() => sidebarOpen ? PinSideBar() : userCtx.setPinned(false)}
            >
              <Col xs={sidebarOpen ? "3" : "12"} className="p-0 m-0">
                {userCtx.pinnedState ? (
                  <RiPushpin2Fill className="leftMenuButtons align-self-center menuButtonColor" />
                ) : (
                  <RiPushpinLine className="leftMenuButtons align-self-center menuButtonColor" />
                )}
              </Col>
              {sidebarOpen && (
                <Col xs="9" className="text-right menuButtonColor p-0 m-0">
                  Pin SideBar
                </Col>
              )}
            </Row>
          </NavItem>
          {canSwitchUI && (
            <NavItem
              title="Switch to Mobile"
              className="fullWidthLinkItem"
              onClick={() => {
                userCtx.setOnMobile(true);
                userCtx.setPinned(true); // switching to mobile
                navigate(constants.ENDPOINTS.mobileHome);
                if (sidebarOpen) toggleSidebar(!sidebarOpen, true);
              }}
            >
              <Row className="m-0 p-0 align-items-center justify-content-center">
                <Col xs={sidebarOpen ? "3" : "12"} className="p-0 m-0 dropbtn">
                  <FaMobile className="leftMenuButtons align-self-center menuButtonColor" />
                </Col>
                {sidebarOpen && (
                  <Col xs="9" className="ps-0 pt-1 menuButtonColor">
                    Switch to Mobile
                  </Col>
                )}
              </Row>
            </NavItem>
          )}
          {showProfile && (
            <NavItem
              key={`${sidebarOpen ? "open" : "closed"}3LinkProfile`}
              title="Profile"
              className="fullWidthLinkItem"
            >
              <ReactStrapNavLink
                tag={NavLink}
                to={"/profile"}
                className="p-0 menuButtonColor"
                active={location.pathname === "/profile"}
                onClick={sidebarOpen ? () => toggleSidebar(!sidebarOpen) : null}
              >
                <Row className="mx-0 my-1 p-0 align-items-center justify-content-center">
                  <Col xs={sidebarOpen ? "3" : "12"} className="p-0 m-0">
                    <FaUserCircle className="leftMenuButtons align-self-center profileButton" />
                  </Col>
                  {sidebarOpen && (
                    <Col
                      xs="9"
                      className={`${
                        location.pathname === "/profile" ? "active" : ""
                      } ps-1 text-nowrap menuButtonColor`}
                    >
                      Profile
                    </Col>
                  )}
                </Row>
              </ReactStrapNavLink>
            </NavItem>
          )}
          <NavItem
            key={`${sidebarOpen ? "open" : "closed"}LinkSignOut`}
            title={userCtx.impersonating ? "Stop Impersonating" : "Sign Out"}
            className="fullWidthLinkItem"
          >
            <ReactStrapNavLink
              className="p-0 menuButtonColor"
              onClick={() => userCtx.signOut(null, false)}
            >
              <Row className="mx-0 my-1 p-0 align-items-center justify-content-center menuButtonColor">
                <Col xs={sidebarOpen ? "3" : "12"} className="p-0 m-0">
                  <VscSignOut
                    style={{ paddingLeft: "2rem" }}
                    className="leftMenuButtons align-self-center signOutButton flipHorizontal"
                  />
                </Col>
                {sidebarOpen && (
                  <Col xs="9" className="ps-1 text-nowrap menuButtonColor">
                    {userCtx.impersonating ? "Stop Impersonating" : "Sign Out"}
                  </Col>
                )}
              </Row>
            </ReactStrapNavLink>
          </NavItem>
        </Nav>
      </div>
    </div>
  );
  if (!currentUser || _.isEqual(userCtx.savedDevice, { isMobile: false }))
    return null;

  //the first way you could fix this is by just defining the function inside of the main component so you can use toggle sidebar
  //the second way is you just pass toggle sideBar as a parameter to your defined functions and call it whenever they click on a link
  function DropdownLinkItemMobile({ item }) {
    const [openDDL, setOpenDDL] = useState(false);
    let navigate = useNavigate();

    function openLink(url) {
      setOpenDDL(false);
      navigate(url);
      toggleSidebar(!sidebarOpen);
    }

    if (item && item.dropdownMenu && item.dropdownMenu.length > 0) {
      return (
        <Dropdown
          nav
          toggle={() => setOpenDDL(!openDDL)}
          title={item.title}
          className="fullWidthLinkItem dropdownList"
          isOpen={openDDL}
          inNavbar={true}
        >
          <DropdownToggle
            // caret={sidebarOpen ? true : false}
            caret={false}
            nav
          >
            <Row className="mx-0 my-1 p-0 align-items-center justify-content-center menuButtonColor">
              <Col xs={12} className="p-0 m-0">
                {item.icon}
              </Col>
            </Row>
          </DropdownToggle>
          <DropdownMenu
            direction={"right"}
            style={{ color: "red" }}
            container="body"
          >
            {_.map(item.dropdownMenu, (link, index) => {
              return (
                <DropdownItem
                  key={index}
                  onClick={() => openLink(link.url)}
                  children={link.title}
                />
              );
            })}
          </DropdownMenu>
        </Dropdown>
      );
    }
  }

  return userCtx.onMobile ? (
    <Sidebar
      open={sidebarOpen}
      onSetOpen={() => toggleSidebar(!sidebarOpen)}
      sidebar={sidebarOpen && mobileMenu} // opened menu
      styles={{
        root: {
          position: "undefined",
        },
        sidebar: {
          position: "fixed",
          background: "white",
          zIndex: 2000,
          minWidth: 40,
          overflowY: "visible",
        },
        content: {
          position: "undefined",
        },
        overlay: {
          backgroundColor: "none",
        },
      }}
    >
      <Row className="mobile-sidebar-toggle p-0">
        <Col className="p-0 transparent-background">
          <Button
            className="px-1 py-1 l2BrightBlue"
            onClick={() => toggleSidebar(!sidebarOpen)}
          >
            <FaBars className="mobile-sidebar-button align-self-center" />
          </Button>
        </Col>
      </Row>
    </Sidebar>
  ) : (
    <>
      <Sidebar
        open={sidebarOpen}
        onSetOpen={() => toggleSidebar(!sidebarOpen)}
        sidebar={sidebarOpen && menu} // opened menu
        shadow={false}
        styles={{
          root: {
            position: "undefined",
          },
          sidebar: {
            position: "fixed",
            background: "white",
            zIndex: 2000,
            minWidth: 250,
            overflowY: "visible",
          },
          content: {
            position: "undefined",
          },
          overlay: {
            zIndex: -10,
            position: "fixed",
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            opacity: 0,
            visibility: "hidden",
            transition: "opacity .3s ease-out, visibility .3s ease-out",
            backgroundColor: "none",
          },
        }}
        defaultSidebarWidth={250}
      >
        {!sidebarOpen && menu} {/* collapsed menu */}
      </Sidebar>
    </>
  );
}
